import type { Bounds } from '@ipfabric/utils';
import { flow } from 'fp-ts/lib/function';
import type { Viewport } from 'pixi-viewport';
import { boundsToPIXIRectangle } from 'utils/pixi/Bounds';
import { fitRectangleToViewport } from 'utils/pixi/fitRectangleToViewport';

const VIEWPORT_MARGIN = 20;

export const fitToViewport = (
  viewport: Viewport,
  margin?: number,
): ((bounds: Bounds) => void) =>
  flow(
    boundsToPIXIRectangle,
    fitRectangleToViewport(viewport, margin ?? VIEWPORT_MARGIN),
  );
